exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ideal-item-button {\n  font-weight: 400;\n  outline: none;\n  line-height: 1;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.775rem;\n  border: 2px solid #dde2ec;\n  color: #484848;\n  border-radius: .5rem; }\n", ""]);

// exports
